import React from 'react';
import { useTranslation } from 'react-i18next';
import layoutStyles from '../../styles/layout.module.css';
import styles from './OurServices.module.css';

const OurServices: React.FC = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: '</>',
      key: 'software',
      customIcon: true
    },
    {
      icon: '📱',
      key: 'mobile',
      customIcon: false
    },
    {
      icon: '☁️',
      key: 'cloud',
      customIcon: false
    },
    {
      icon: '⚙️',
      key: 'itSupport',
      customIcon: false
    },
    {
      icon: '🤝',
      key: 'consulting',
      customIcon: false
    }
  ];

  return (
    <div className={styles.colorWrapper}>
      <section id="OurServices" className={`${layoutStyles.container} ${styles.ourServices}`}>
        <h2>{t('ourServices.title')}</h2>
        <div className={styles.servicesGrid}>
          {services.map((service, index) => (
            <div key={index} className={styles.serviceCard}>
              <div className={styles.iconWrapper}>
                {service.customIcon ? (
                  <span className={styles.codeIcon}>{service.icon}</span>
                ) : (
                  <span className={styles.icon}>{service.icon}</span>
                )}
              </div>
              <h3>{t(`ourServices.services.${service.key}.title`)}</h3>
              <p>{t(`ourServices.services.${service.key}.description`)}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default OurServices;

